import { motion } from "motion/react";

const LoadingScreen = () => (
  <motion.div
    className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#0a0a0a]"
    exit={{ opacity: 0 }}
    initial={{ opacity: 1 }}
    transition={{ duration: 0.6, ease: "easeInOut" }}
  >
    <p className="font-mono text-sm text-zinc-600">Loading the prayer globe...</p>

    <div className="mt-4 flex gap-1.5">
      <span className="loading-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
      <span className="loading-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
      <span className="loading-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
    </div>
  </motion.div>
);

export default LoadingScreen;
